<template>
  <div class="page-answer">
    <div class="top">
      <div class="reject-reason" v-if="questionnairePlanInfo && questionnairePlanInfo.auditStatus == 2">
        <van-image
          width="12"
          height="12"
          fit="cover"
          :src="require('@/assets/imgs/error.png')"
        />
        <span class="reason-text">
          {{questionnairePlanInfo.auditFailReason}}
        </span>
      </div>
      <div class="content">
        <div class="header" v-if="questionnairePlanInfo && patientInfo">
          <h2 class="title">
            {{ questionnairePlanInfo.name }}
          </h2>
          <!-- <div class="patient-info">
            <img class="avatar" :src="patientInfo.avatar" alt="">
            <span>
              {{patientInfo.name}} {{ { '1': '男', '2': '女' }[patientInfo.sex] }} {{patientInfo.age}}岁
            </span>
          </div> -->
          <van-image
            v-if="questionnairePlanInfo.auditStatus == 3"
            class="audit-img"
            width="48"
            height="48"
            fit="cover"
            :src="require('@/assets/imgs/audit_pass.png')"
          />
          <van-image
            v-if="questionnairePlanInfo.auditStatus == 2"
            class="audit-img"
            width="48"
            height="48"
            fit="cover"
            :src="require('@/assets/imgs/audit_reject.png')"
          />
          <van-image
            v-if="questionnairePlanInfo.auditStatus == 1"
            class="audit-img"
            width="48"
            height="48"
            fit="cover"
            :src="require('@/assets/imgs/audit_wait.png')"
          />
        </div>
        <div class="question-list">
          <div class="question-item"
            v-for="(question, index) in questionnaireAnswer.questionAnswerList"
            :key="question.id">
            <span class="question-title" :class="{'required': question.questionDTO.isRequired}">
              {{index + 1}}. {{question.questionDTO.title}}
            </span>
            <div class="answer-area">
              <van-uploader
                v-if="question.questionDTO.type === 8 && question.fileList && question.fileList.length > 0"
                accept="image/*"
                :class="['preview-images']"
                v-model="question.fileList"
                :show-upload="false"
                :deletable="false"
              >
              </van-uploader>
              <span v-else class="text">
                {{question | answer}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="questionnairePlanInfo && (questionnairePlanInfo.auditStatus == 1 || questionnairePlanInfo.auditStatus == 2)">
      <van-button type="primary" disabled v-if="questionnairePlanInfo.auditStatus == 1">平台审核中</van-button>
      <van-button @click="handleModify" type="primary" v-if="questionnairePlanInfo.auditStatus == 2">修改后重新提交</van-button>
    </div>
  </div>
</template>

<script>
import intersectionBy from 'lodash/intersectionBy';

export default {
  name: "answer",
  data() {
    return {
      header: {
        title: '健康反馈',
      },
      patientInfo: {},
      questionnaireAnswer: { questionAnswerList: [] },
      questionnairePlanInfo: {}
    }
  },
  mounted() {
    const { code } = this.$route.query; 
    this.initAnswer(code);
    this.readonly = true;
  },
  filters: {
    answer(question) {
      if (question.result) {
        return question.result;
      } else {
        const filterIds = question.optionsResults.map(v => ({
          optionsRelationId: v.optionsId
        }))
        const list = intersectionBy(question.questionDTO.optionList, filterIds, i => i.optionsRelationId);
        return list.map(i => i.option).join(';') || '无'
      }
    }
  },
  methods: {
    async initAnswer(code) {
      const { data: { patientInfo = {}, questionnaireAnswer = {}, questionnairePlanInfo = {} } } = await this.$fetch.fetchGetQuestionnaireResult({
          taskCode: code
      });
      questionnaireAnswer.questionAnswerList.forEach(question => {
        if(question.questionDTO.type === 8) {
          question.fileList = question.result ? question.result.split(';').map(url => ({url, name: '', uid: ''})) : [];
        }
      })
      this.patientInfo = patientInfo;
      this.questionnaireAnswer = questionnaireAnswer;
      this.questionnairePlanInfo = questionnairePlanInfo;
    },
    handleModify() {
      this.$router.push({ path: '/', query: { ...this.$route.query, mode: 'edit' } });
    }
  }
};
</script>
<style lang="less" scoped>
.page-answer {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .top {
    flex: 1 1 auto;
    overflow: auto;
  }
  .app-upload {
    /deep/ .van-uploader__input-wrapper {
      > input {
        width: 0;
        height: 0;
      }
    }
  }
  .reject-reason {
    width: 100%;
    padding: 10px 12px;
    background: #FFEEEB;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: -10px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF4E47;
    .van-image {
      flex: 0 0 auto;
    }
    .reason-text {
      margin-left: 3px;
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .content {
    margin: 10px 0 30px;
    .header {
      padding: 12px 16px;
      background-color: #fff;
      margin-bottom: 10px;
      position: relative;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #262626;
        line-height: 27px;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        max-width: 95%;
      }
      .desc {
        span {
          display: block;
        }
        font-size: 14px;
        font-weight: 400;
        color: #8C8C8C;
        line-height: 21px;
        margin: 8px 0 16px;
      }
      .patient-info {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        line-height: 16px;
        .avatar {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
      .audit-img {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .question-list {
      background-color: #fff;
      .question-title {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        line-height: 1.2;
        display: flex;
        margin-bottom: 20px;
        &.required::before {
          display: inline-block;
          content: '*';
          color: #FF4E47;
        }
      }
      .question-item {
        padding: 20px 20px 12px;
        .answer-area {
          margin: 0 8px;
          width: auto;
          .text {
            display: block;
            padding: 10px;
            background: #F5F5F5;
          }
        }
      }
    }
  }
  .footer {
    flex: 0 0 auto;
    height: 52px;
    width: 100%;
    padding: 0 16px;
    display: flex;
    align-items: center;
    .van-button {
      width: 100%;
    }
  }
}
</style>
